var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M95.1153 0.34021L138.32 43.5L95.1153 86.6597L83.8074 75.3402L107.672 51.5H0V35.5H107.672L83.8074 11.6597L95.1153 0.34021Z","fill":"#E6E5E1"}));
}

ArrowInline.defaultProps = {"viewBox":"0 0 139 87","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
